// src/constants/textConstants.js
export const HOME_SCREEN_TEXT = {
  HERO_TITLE: "Discover Amazing Products Near You",
  HERO_SUBTITLE: "Get everything you need delivered to your doorstep",
  FEATURED_CATEGORIES: "Featured Categories",
  POPULAR_PRODUCTS: "Popular Products Near You",
  TRENDING_SERVICES: "Trending Services",
  NEARBY_SHOPS: "Shops Near You",
  VIEW_ALL: "View All",
  ADD_TO_CART: "Add to Cart",
  SEE_DETAILS: "See Details",
  DELIVERY_TIME: "Delivery in {time} mins",
  RATING: "{rating} ({count} reviews)",
};

export const url = {
  // baseAPIUrl: "https://nearmeindapi.nearmeind.com",
  baseAPIUrl: "https://nearmeindwebapi.nearmeind.com",

  // baseAPIUrl: "https://mynearmeindapi.nearmeind.in",

  serviceImageStartingPath: "https://nearmeind.com/ServiceImage/",
  productImageStartingPath: "https://nearmeind.com/AdminAssets/images/",
  reviewImageStartingPath: "https://nearmeind.com/ReviewImage",
  // advertisementImageStartingPath: "https://nearmeind.com/AdsImage/",
  advertisementImageStartingPath: "https://nearmeind.com/UploadedImages/",
};

export const BUTTON_TEXT = {
  EXPLORE_NOW: "Explore Now",
  SHOP_NOW: "Shop Now",
  BOOK_NOW: "Book Now",
};

export const API_KEY = {
  // OLA_API_KEY: "TCaiyjfE8HKL1rbzhEz6nsszaR4o9nDIQaMWzBoR",
  OLA_API_KEY: "Ik7QIW7TR71Nv3qDofXNBKiSlzBf0Rap6nAB8CUu",
  // OLA_API_KEY: "uR9YufLTCvnb2SEurhSeYLK7ktERJxwQFDCpA85y",
};

export const ERROR_MESSAGES = {
  LOCATION_REQUIRED: "Please select your location to see relevant results",
  NETWORK_ERROR: "Network error. Please try again.",
};
